
import {Component, Vue, Watch} from 'vue-property-decorator';
import AppPageHeader from "@/components/AppPageHeader.vue";
import {IReport} from "@/modules/Report/interfaces/report.interface";
import ParksTable from "@/modules/ParksConfig/components/ParksTable.vue";
import ParkEventsPopup from "@/modules/ParksConfig/components/ParkEvents/ParkEventsPopup.vue";
import {IDialogStoreState} from "@/modules/Popup/interfaces/dialog.interface";
import ParkEventsLogPopup from "@/modules/ParksConfig/components/ParkEvents/ParkEventsLogPopup.vue";

@Component({
  components: {
    ParkEventsLogPopup,
    ParkEventsPopup,
    ParksTable,
    AppPageHeader,
  },
})
export default class PageParksConfig extends Vue {
  $refs: any;
  isLoading: boolean = true;

  get popups(): IDialogStoreState { return this.$store.state.dialog; }
  get tableList(): IReport.ReportType { return this.$store.getters['parksConfig/sortedList']; }

  async created() {
    try {
      await this.$store.dispatch('auth/init');
      await this.$store.dispatch('book/initBooksForPage', this.$route.name);
      await this.$store.dispatch('initialized');
      await this.$store.dispatch('parksConfig/getTable');
      this.isLoading = false;
    }
    catch (error) { await this.$store.dispatch('handleError', error) }
  }
}
